import { financeAPI } from "../../axios";
export const actions = {
    createDUServiceFeeTemplate(context, data){
        return financeAPI.post(`DeliveryUnitServiceFeeTemplate/Add`, data);
    },
    updateDUServiceFeeTemplate(context, data){
        return financeAPI.put(`DeliveryUnitServiceFeeTemplate/${data.id}`, data);
    },
    getDUServiceFeeTemplate(context, data){
        return financeAPI.get(`DeliveryUnitServiceFeeTemplate/${data}`);
    },
    removeDUServiceFeeTemplate(context, data){
        return financeAPI.delete(`DeliveryUnitServiceFeeTemplate/${data}`);
    },
    getDUServiceFeeTemplatesByService(context, data){
        return financeAPI.get(`DeliveryUnitServiceFeeTemplate/DeliveryUnitService/${data}`);
    },
    addMultipleFee(context, {deliveryUnitServiceFeeTemplateId, data}){
        return financeAPI.post(`DeliveryUnitServiceFeeTemplate/Fees/Add/${deliveryUnitServiceFeeTemplateId}`, data);
    },
    removeFee(context, data){
        return financeAPI.post(`DeliveryUnitServiceFeeTemplate/Fees/Remove`, data);
    },
    updateFee(context, data){
        return financeAPI.put(`DeliveryUnitServiceFeeTemplate/Fee/Update/${data.id}`, data);
    }
}